/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {clearProfilePhotoInternal} from '../api'

export const useMutationClearProfilePhotoInternal = createReactQueryMutationHook('clearProfilePhotoInternal', clearProfilePhotoInternal)
